/*******************************************************
 * 1. OPTIONAL ADDONS
 *******************************************************/

/**
 * Initialize addon option selectors
 */
function initializeAddonSelectors() {
  /**
   * Event listener for change events on each addon option selector.
   * When an option is selected:
   * - Update price, SKU, and image for the corresponding addon.
   * - Mark the addon as selected (enable its input, add 'checked-box' class).
   * - Trigger a recalculation of the total price.
   */
  const addonsEl = document.querySelector('#product-addons')
  document.querySelectorAll('.addon-option-selector').forEach(selectElement => {
    selectElement.addEventListener('change', function () {
      // Get the selected option and its data attributes.
      const selectedOption = this.options[this.selectedIndex];
      const productId = selectedOption.getAttribute('data-product-id');
      const productEl = addonsEl.querySelector(`.product-addon[data-product-id="${productId}"]`);
      const inputEl = productEl.querySelector('input');

      const imageId = selectedOption.getAttribute('data-image-id');
      const price = parseFloat(selectedOption.getAttribute('data-price'));
      const compareAtPrice = parseFloat(selectedOption.getAttribute('data-compare-at-price'));
      const sku = selectedOption.getAttribute('data-sku');

      // Format prices (assuming prices are provided in cents)
      const priceFormatted = `$${(price / 100).toFixed(2)} CAD`;
      const compareAtPriceFormatted = `$${(compareAtPrice / 100).toFixed(2)} CAD`;

      // Enable the addon input and visually mark it as checked.
      productEl.classList.add('checked-box');
      inputEl.removeAttribute('disabled');
      inputEl.checked = true;

      // Update the addon's price in the DOM.
      const priceEl = document.querySelector(`#product-addon-price-${productId}`);
      if (priceEl) {
        priceEl.textContent = priceFormatted;
      }

      // Update SKU if available.
      if (sku) {
        const skuEl = productEl.querySelector('.product-meta__sku');
        if (skuEl) {
          skuEl.innerText = `Part No: ${sku}`;
        }
      }

      // Update compare-at-price if applicable.
      const compareAtPriceEl = document.querySelector(`#product-addon-compare-at-price-${productId}`);
      if (compareAtPriceEl) {
        compareAtPriceEl.textContent = (compareAtPrice > price) ? compareAtPriceFormatted : '';
      }

      // Update the addon product image if the update function exists.
      if (typeof update_image_for_addon_product === 'function') {
        update_image_for_addon_product(productId, imageId);
      }

      // Recalculate total price including addons.
      if (typeof show_total_price === 'function') {
        show_total_price();
      }
    });
  });
}
initializeAddonSelectors();

/**
 * Initialize addon checkboxes
 */
function initializeAddonCheckboxes() {
  /**
   * Event listener for addon checkbox toggles.
   * Adds or removes the 'checked-box' class and recalculates the total price.
   */
  document.querySelectorAll('input[type=checkbox].product-addon-checkbox').forEach(checkbox => {
    checkbox.addEventListener('change', function () {
      // Toggle the visual 'checked-box' class.
      if (this.checked) {
        this.parentElement.classList.add('checked-box');
      } else {
        this.parentElement.classList.remove('checked-box');
      }
      // Recalculate the total price whenever an addon is checked/unchecked.
      show_total_price();
    });
  });
}
initializeAddonCheckboxes();

/**
 * Adds selected addon items to the Shopify cart.
 * Gathers checked addon items, builds an items array with line item properties for SKU and MFT SKU,
 * and posts to the cart endpoint.
 */
async function addAddonsToCart() {
  const items = [];

  // Gather data from all checked addon checkboxes.
  document.querySelectorAll('input[type=checkbox].product-addon-checkbox:checked').forEach(checkbox => {
    const productId = checkbox.getAttribute('data-product-id');
    const selectedOption = document.querySelector(`#addon-option-selector-${productId} option:checked`);

    // Get SKU and MFT SKU data from the selected option
    const sku = selectedOption.getAttribute('data-sku');
    const mftPartNumber = selectedOption.getAttribute('data-mft-part-number');

    // Build the item object with line item properties
    const item = {
      id: selectedOption.getAttribute('data-variant-id'),
      quantity: parseInt(checkbox.getAttribute('data-quantity'), 10),
    };

    // Add line item properties for SKU and MFT SKU if they exist
    if (sku || mftPartNumber) {
      item.properties = {};

      if (sku) {
        item.properties['Part Number'] = sku;
      }

      if (mftPartNumber) {
        item.properties['Mft Part Number'] = mftPartNumber;
      }
    }

    items.push(item);
  });

  // Add required addons if they exist
  const requiredAddons = getRequiredAddons();
  items.push(...requiredAddons);

  if (!items.length) return;

  const url = window.Shopify.routes.root + 'cart/add.js';

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || 'Failed to add items to cart');
    }

    const data = await response.json();

    return data;
  } catch (error) {
    console.error('Error adding items to cart:', error);
    throw error;
  }
}

/**
 * Updates the image for a given addon product.
 * Displays the image matching the provided image_id and hides others.
 * @param {string} productId - The product ID.
 * @param {string} imageId - The image ID to display.
 */
function update_image_for_addon_product(productId, imageId) {
  // Get all images associated with the addon product.
  const images = document.querySelectorAll(`.images-for-${productId}`);
  if (!imageId) return;

  // Determine if variant images are available.
  const hasVariantImages = document.querySelector(`#addon-option-selector-${productId}`).style.display !== 'none';

  // If there's only one image or no variant images, do nothing.
  if (images.length === 1 || !hasVariantImages) return;

  // Show the image matching imageId; hide others.
  images.forEach(image => {
    image.style.display = (image.getAttribute('data-image-id') === imageId) ? 'block' : 'none';
  });
}

/**
 * Listen for a custom event triggered from the product form
 * that signals addons should be added to the cart.
 */
// Listen for the addon event and then process addon updates.
document.addEventListener('on:cart:addon:add', async () => {
  try {
    // Wait for the addons update to finish
    await addAddonsToCart();
    document.documentElement.dispatchEvent(
      new CustomEvent('on:addons:complete', { bubbles: true })
    );
    // product-form.js will dispatch on:line-item:change:end after receiving on:addons:complete
  } catch (error) {
    console.error('Error in addon update:', error);
    // Dispatch completion even on error so product-form.js can continue
    document.documentElement.dispatchEvent(
      new CustomEvent('on:addons:complete', { bubbles: true })
    );
  }
});

/*******************************************************
 * 2. REQUIRED ADDONS
 *******************************************************/

/**
 * Get selected required addons for cart
 */
function getRequiredAddons() {
  const selectedVariants = [];
  const requiredAddonPickers = document.querySelectorAll('required-variant-picker');

  requiredAddonPickers.forEach(picker => {
    // Get the selected variant from the picker's variant property
    if (picker.variant && picker.variant.id) {
      selectedVariants.push(picker.variant.id);
    } else {
      // Fallback: manually get the selected variant
      const selectedInput = picker.querySelector('input[type="radio"]:checked');
      if (selectedInput) {
        // Call getSelectedVariant method if available
        if (typeof picker.getSelectedVariant === 'function') {
          const variant = picker.getSelectedVariant();
          if (variant && variant.id) {
            selectedVariants.push(variant.id);
          }
        }
      }
    }
  });

  return selectedVariants.map(id => ({
    id: parseInt(id),
    quantity: 1,
    properties: { '_required_addon': 'true' }
  }));
}

function initializeRequiredAddons() {
  // Now using required-variant-picker custom elements
  const requiredAddonPickers = document.querySelectorAll('required-variant-picker');
  if (!requiredAddonPickers.length) return;

  // Listen for changes on required addon variant pickers
  requiredAddonPickers.forEach(picker => {
    picker.addEventListener('change', () => {
      show_total_price();
    });
  });
}
initializeRequiredAddons();

/*******************************************************
 * 3. PRODUCT OPTIONS (inputs/textareas/selects)
 *******************************************************/

/**
 * Initialize product options validation
 */
const initializeProductOptionsValidation = () => {
  const form = document.querySelector('form.js-product-form-main');
  if (!form) return;

  const requiredCheckboxContainers = form.querySelectorAll('.required');

  requiredCheckboxContainers.forEach(container => {
    const checkboxes = container.querySelectorAll('input[type="checkbox"]');

    container.addEventListener('change', function (event) {
      if (event.target.type === 'checkbox' && event.target.checked) {
        // Remove 'required' from all checkboxes in this container once one is checked
        checkboxes.forEach(checkbox => {
          checkbox.required = false;
        });
      } else {
        // If no checkboxes are checked, reapply 'required' to all
        const anyChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);
        checkboxes.forEach(checkbox => {
          checkbox.required = !anyChecked;
        });
      }
    });
  });
};
initializeProductOptionsValidation();

/*******************************************************
 * 4. VALIDATION & ADD TO CART
 *******************************************************/

/**
 * Validate all required fields (product options, required addons)
 * Returns true if all required fields are valid, false otherwise
 */
const validateAllRequiredFields = () => {
  const form = document.querySelector('.js-product-form');
  if (!form) return true;

  let isValid = true;

  // Clear previous highlights
  form.querySelectorAll('.highlight-required').forEach(el => {
    el.classList.remove('highlight-required');
  });

  // Also clear highlights from required addon pickers
  document.querySelectorAll('required-variant-picker.highlight-required').forEach(el => {
    el.classList.remove('highlight-required');
  });

  // console.log('Form found:', form);
  // console.log('Required inputs found:', form.querySelectorAll('[required]').length);
  // console.log('Required containers found:', form.querySelectorAll('.required').length);

  // Check inputs with required attribute
  form.querySelectorAll('[required]').forEach(input => {
    let fieldValid = false;

    if (input.type === 'checkbox') {
      const container = input.closest('.required');
      fieldValid = container ? container.querySelector('input:checked') : input.checked;

      if (!fieldValid) {
        // Highlight the container or the input itself
        const elementToHighlight = container || input;
        elementToHighlight.classList.add('highlight-required');
      }
    } else if (input.type === 'radio') {
      // For radio buttons, check if any in the same name group is selected
      const radioGroup = form.querySelectorAll(`input[name="${input.name}"]`);
      fieldValid = Array.from(radioGroup).some(radio => radio.checked);

      if (!fieldValid) {
        // Highlight all radio buttons in the group
        radioGroup.forEach(radio => {
          radio.classList.add('highlight-required');
        });
      }
    } else {
      // For other input types (text, textarea, select, etc.)
      fieldValid = input.value.trim() !== '';

      // Also check for custom validity (like VIN validation)
      if (fieldValid && input.validity && !input.validity.valid) {
        fieldValid = false;
      }

      if (!fieldValid) {
        input.classList.add('highlight-required');
      }
    }

    if (!fieldValid) {

      isValid = false;
    }
  });

  // Check containers with required class (for checkbox groups)
  form.querySelectorAll('.checkbox-required').forEach(container => {
    const hasCheckedInput = container.querySelector('input:checked');

    if (!hasCheckedInput) {
      container.classList.add('highlight-required');
      isValid = false;
    }
  });

  // Check required addons
  const requiredAddonPickers = document.querySelectorAll('required-variant-picker');
  requiredAddonPickers.forEach(picker => {
    const selectedInput = picker.querySelector('input[type="radio"]:checked');

    if (!selectedInput) {
      // Highlight the variant picker container
      picker.classList.add('highlight-required');
      isValid = false;
    }
  });

  return isValid;
};

/**
 * Handle add to cart button click
 * Validates all required fields before allowing form submission
 */
function handleAddToCartClick(event) {
  // Only validate if button is not disabled
  if (!this.hasAttribute('disabled')) {
    const isValid = validateAllRequiredFields();

    if (!isValid) {
      event.preventDefault();
      event.stopPropagation();

      // Scroll to first invalid field
      const firstInvalid = document.querySelector('.highlight-required');
      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }
}

/**
 * Initialize add to cart button behavior
 * Attaches validation and handles form submission
 */
const initializeAddToCartButton = () => {
  const addBtn = document.querySelector('.product-info__add-button button');
  if (!addBtn) return;

  // Remove existing listener to prevent duplicates
  addBtn.removeEventListener('click', handleAddToCartClick);
  addBtn.addEventListener('click', handleAddToCartClick);
};
initializeAddToCartButton();

/*******************************************************
 * 5. PRICE CALCULATION (applies to all)
 *******************************************************/

/**
 * Calculates and displays the total price including base product and selected addons.
 */
function show_total_price() {
  // Get base product price and quantity.
  let productPriceText = document.querySelector('.product-info__price .price__current').textContent;
  let productPrice = parseFloat(productPriceText.replace(/[^0-9.]/g, ''));
  const priceForm = document.querySelector('.js-product-form')
  const quantitySelector = priceForm.querySelector('input[name="quantity"');
  const productQty = parseInt(quantitySelector.value, 10);

  // If quantity is invalid, clear the total price display.
  if (isNaN(productQty)) {
    document.querySelector('#total_price_with_addons span').textContent = '';
    document.querySelector('#total_price_container').classList.remove('total_price_selected');
    return;
  }

  // Collect normal addon data from checked checkboxes.
  const normalAddons = [];
  document.querySelectorAll('input[type=checkbox].product-addon-checkbox:checked').forEach(checkbox => {
    const productId = checkbox.getAttribute('data-product-id');
    const selectedOption = document.querySelector(`#addon-option-selector-${productId} option:checked`);
    normalAddons.push({
      id: selectedOption.getAttribute('data-variant-id'),
      quantity: parseInt(checkbox.getAttribute('data-quantity'), 10),
      price_each: parseFloat(selectedOption.getAttribute('data-price')) / 100,
    });
  });

  // Collect required addon data from variant pickers
  const requiredAddons = [];
  const requiredAddonPickers = document.querySelectorAll('required-variant-picker');
  requiredAddonPickers.forEach(picker => {
    if (picker.variant && picker.variant.price) {
      requiredAddons.push({
        id: picker.variant.id,
        quantity: 1,
        price_each: picker.variant.price / 100, // Convert from cents to dollars
      });
    }
  });

  // Calculate the total price: base price * quantity + sum(normal addon prices) + sum(required addon prices)
  let totalPrice = productPrice * productQty;

  normalAddons.forEach(addon => {
    totalPrice += addon.price_each * addon.quantity;
  });

  requiredAddons.forEach(addon => {
    totalPrice += addon.price_each * addon.quantity;
  });

  // Update UI styling based on whether any addons are selected or multiple quantities exist.
  const totalPriceContainer = document.querySelector('#total_price_container');
  const hasAnyAddons = normalAddons.length > 0 || requiredAddons.length > 0;
  if (hasAnyAddons || productQty > 1) {
    totalPriceContainer.classList.add('total_price_selected');
  } else {
    totalPriceContainer.classList.remove('total_price_selected');
  }

  // Format and display the total price.
  const currencyCode = window.theme?.settings?.currencyCode;
  const priceFormatted = `$${totalPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${currencyCode}`;
  document.querySelector('#total_price_with_addons span').textContent = priceFormatted;
}
// Listen for variant change events to recalculate total price.
document.addEventListener('on:variant:change', function () {
  show_total_price();
});
document.addEventListener('on:required-variant:change', function () {
  show_total_price();
});

// Re-initialize addons when product section is replaced (for combined listings)
document.addEventListener('product:replaced', () => {
  initializeAddonSelectors();
  initializeAddonCheckboxes();
  initializeProductOptionsValidation();
  initializeAddToCartButton();
  initializeRequiredAddons();
  show_total_price();
});